module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1534-11a559ad31d41bb062528b658b96f91a.png";